<template>
  <div :id="id"></div>
</template>
<script>
import G2 from "@antv/g2";

export default {
  name: "piechart",
  props: ["chartData", "chartId"],
  data() {
    return {
      data: [],
      id: "",
      chart: {}
    };
  },
  watch: {
    chartData(newVal) {
      this.data = newVal;
      // console.log(newVal)
      this.chart.changeData(this.data);
    }
  },
  created() {
    this.id = this.chartId;
    this.data = this.chartData;
  },
  mounted() {
    let max = 0;
    this.data.forEach(function (obj) {
      if (obj.value > max) {
        max = obj.value;
      }
    });
    G2.Shape.registerShape('interval', 'sliceShape', {
      draw: function draw(cfg, container) {
        var points = cfg.points;
        var origin = cfg.origin._origin;
        var percent = origin.value / max;
        var xWidth = points[2].x - points[1].x;
        var width = xWidth * percent;
        var path = [];
        path.push(['M', points[0].x, points[0].y]);
        path.push(['L', points[1].x, points[1].y]);
        path.push(['L', points[0].x + width, points[2].y]);
        path.push(['L', points[0].x + width, points[3].y]);
        path.push('Z');
        path = this.parsePath(path);
        return container.addShape('path', {
          attrs: {
            fill: cfg.color,
            path: path
          }
        });
      }
    });
    this.chart = new G2.Chart({
      container: this.id,
      forceFit: true,
      height: document.querySelector("#" + this.id + "").clientHeight,
      width: document.querySelector("#" + this.id + "").clientWidth,
      padding: "auto"
    });
    this.chart.source(this.data);
    this.chart.coord('theta', {
      radius: 0.8
    });
    this.chart.intervalStack().position('value').color('type').shape('sliceShape').label('value', {
      offset: 2,
      textStyle: {
        fill: '#fff'
      },
      formatter: function formatter(val, item) {
        return val+'%';
      }
    });
    this.chart.legend({
      textStyle: {
        fill: '#fff'
      },
      position: 'right-center'
    })
    this.chart.render();
  }
};
</script>
<style lang="scss">
#analysisType-result,
#analysisType-chart {
  width: 100%;
  height: 100%;
}
</style>
